import send from "../../util/request";
// 采购建议列表
export const getReplenish = (params) => send({ url: '/ipp/inventory/replenish', method: 'POST', data: params, options: { loading: true } });

// 采购建议-分类树
export const getInventoryOutCategories = (params) => send({ url: '/ipp/inventory/out-categories', method: 'POST', data: params, options: { loading: true } });

// 加入订货清单
export const inventoryAddList = (params) => send({ url: '/ipp/inventory/add-list', method: 'POST', data: params, options: { loading: true } });

//订货清单-列表
export const inventoryCartList = (params) => send({ url: '/ipp/inventory/cart-list', method: 'POST', data: params, options: { loading: true } });

//订货清单-清空数量
export const inventoryCartListClearNumber = (params) => send({ url: '/ipp/inventory/cart-clear-number', method: 'POST', data: params, options: { loading: true } });

//清空订货清单列表
export const inventoryClearList = (params) => send({ url: '/ipp/inventory/clear-list', method: 'POST', data: params, options: { loading: true } });

// 订货单确认
export const inventoryOrderConfirm = (params) => send({ url: '/ipp/inventory/order-confirm', method: 'POST', data: params, options: { loading: true } });

// 订货单列表
export const inventoryOrders = (params) => send({ url: '/ipp/inventory/orders', method: 'POST', data: params, options: { loading: true } });

// 订货单取消
export const inventoryOrderCancel = (params) => send({ url: '/ipp/inventory/cancel-order', method: 'POST', data: params, options: { loading: true } });

// 再来一单/重新下单
export const inventoryAgainOrder = (params) => send({ url: '/ipp/inventory/again-order', method: 'POST', data: params, options: { loading: true } });

// 订货单详情
export const inventoryOrder = (params) => send({ url: '/ipp/inventory/order', method: 'POST', data: params, options: { loading: true } });

// 订货单创建
export const inventoryCreateOrder = (params) => send({ url: '/ipp/inventory/create-order', method: 'POST', data: params, options: { loading: true } });

// 订货清单-删除
export const inventoryDeleteList = (params) => send({ url: '/ipp/inventory/delete-list', method: 'POST', data: params, options: { loading: true } });

//订购订单-修改数量
// export const inventoryUpdateList = (params) => send({ url: '/ipp/inventory/update-list', method: 'POST', data: params, options: { loading: true } });
export const inventoryUpdateList = (params) => send({ url: '/ipp/inventory/update-list', method: 'POST', data: params, options: { loading: false } });

//同主体仓库列表
export const inventorySuppliers = (params) => send({ url: '/ipp/inventory/suppliers', method: 'POST', data: params, options: { loading: true } });

//校验供应商商品
export const inventoryMatchSupplier = (params) => send({ url: '/ipp/inventory/match-supplier', method: 'POST', data: params, options: { loading: true } });

// 门店下单时间-列表
export const inventoryOrderTimeList = (params) => send({ url: '/ipp/inventory/order-time-list', method: 'POST', data: params, options: { loading: true } });

// 门店下单时间-添加
export const inventoryOrderTimeAdd = (params) => send({ url: '/ipp/inventory/order-time-add', method: 'POST', data: params, options: { loading: true } });

// 门店下单时间-更新
export const inventoryOrderTimeUpdate = (params) => send({ url: '/ipp/inventory/order-time-update', method: 'POST', data: params, options: { loading: true } });

// 门店下单时间-删除
export const inventoryOrderTimeDelete = (params) => send({ url: '/ipp/inventory/order-time-delete', method: 'POST', data: params, options: { loading: true } });

// 门店下单时间-分类列表
export const inventoryOrderTimeCategories = (params) => send({ url: '/ipp/inventory/order-time-categories', method: 'POST', data: params, options: { loading: true } });

// 订货清单-添加商品-品牌列表
export const inventoryBrandList = (params) => send({ url: '/ipp/inventory/brand-list', method: 'POST', data: params, options: { loading: true } });

// 订货清单-添加商品-分类列表
export const inventoryCategoryList = (params) => send({ url: '/ipp/inventory/category-list', method: 'POST', data: params, options: { loading: true } });

// 订货订单-添加商品-商品列表
export const inventorySupplierSales = (params) => send({ url: '/ipp/inventory/supplier-sales', method: 'POST', data: params, options: { loading: true } });

// 常购清单-列表
export const inventoryOpenList = (params) => send({ url: '/ipp/inventory/oftens', method: 'POST', data: params, options: { loading: true } });

// 常购清单-保存/编辑
export const inventorySaveOften = (params) => send({ url: '/ipp/inventory/save-often', method: 'POST', data: params, options: { loading: true } });

// 常购清单-删除
export const inventoryDeleteOften = (params) => send({ url: '/ipp/inventory/delete-often', method: 'POST', data: params, options: { loading: true } });

// 常购清单-商品管理-加入订货清单
export const inventoryOftenCoCart = (params) => send({ url: '/ipp/inventory/often-to-cart', method: 'POST', data: params, options: { loading: true } });

// 常购清单-商品管理-列表
export const inventoryOften = (params) => send({ url: '/ipp/inventory/often', method: 'POST', data: params, options: { loading: true } });

// 常购清单-商品管理-删除
export const inventoryDeleteOftenList = (params) => send({ url: '/ipp/inventory/delete-often-list', method: 'POST', data: params, options: { loading: true } });

// 常购清单-商品管理-添加
export const inventoryAddOftenList = (params) => send({ url: '/ipp/inventory/add-often-list', method: 'POST', data: params, options: { loading: true } });

// 订货自动提交设置-列表
export const inventoryAutoList = (params) => send({ url: '/ipp/inventory/auto-list', method: 'POST', data: params, options: { loading: true } });

//订货自动i提交设置-保存
export const inventoryAutoSave = (params) => send({ url: '/ipp/inventory/auto-save', method: 'POST', data: params, options: { loading: true } });

//订货自动i提交设置-启用
export const inventoryAutoEnabled = (params) => send({ url: '/ipp/inventory/auto-enabled', method: 'POST', data: params, options: { loading: true } });

//订货自动i提交设置-禁用
export const inventoryAutoDisabled = (params) => send({ url: '/ipp/inventory/auto-disabled', method: 'POST', data: params, options: { loading: true } });

//订货自动i提交设置-删除
export const inventoryAutoDelete = (params) => send({ url: '/ipp/inventory/auto-delete', method: 'POST', data: params, options: { loading: true } });

// CPM销售采购清单-修改采购数量
export const inventoryUpdatePurchaseList = (params) => send({ url: '/ipp/inventory/update-purchase-list', method: 'POST', data: params, options: { loading: true } });

// CPM销售采购清单-指定供应商
export const inventoryAssignSupplier = (params) => send({ url: '/ipp/inventory/assign-supplier', method: 'POST', data: params, options: { loading: true } });

// // 订货订单-添加商品-商品列表
// export const inventorySupplierSales = (params) => send({ url: '/ipp/inventory/supplier-sales', method: 'POST', data: params, options: { loading: true } });